import i18n from "../../../../constants/i18n";
import { getSupervisorReceiptConfigurationStore } from "../../../../stores/supervisor-store/supervisor-receipt-configuration-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ReceiptsConfigurationInputs from "./ReceiptsConfigurationInputs";
import SaveReceiptsConfiguration from "./SaveReceiptsConfiguration";

const SupervisorReceiptConfigurationInput = withLiteObserverAndTheme(
  (props) => {
    const { theme } = props;
    const { colors } = theme;
    const showInputs =
      getSupervisorReceiptConfigurationStore().showReceiptConfigutationDashboard.get();

    return !showInputs ? null : (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={500}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <ReceiptsConfigurationInputs
          labelPrice={i18n.get("DESCRIPTION_PRICING")}
          labelThreshold={i18n.get("DESCRIPTION_THRESHOLD")}
          labelDiscount={i18n.get("DESCRIPTION_DISCOUNT")}
          keyPrice={"descriptionPricing"}
          keyThreshold={"descriptionThreshold"}
          keyDiscount={"descriptionDiscount"}
        />
        <ReceiptsConfigurationInputs
          labelPrice={i18n.get("PICTURE_PRICING")}
          labelThreshold={i18n.get("PICTURE_THRESHOLD")}
          labelDiscount={i18n.get("PICTURE_DISCOUNT")}
          keyPrice={"picturePricing"}
          keyThreshold={"pictureThreshold"}
          keyDiscount={"pictureDiscount"}
        />
        <ReceiptsConfigurationInputs
          labelPrice={i18n.get("REPORT_PRICING")}
          labelThreshold={i18n.get("REPORT_THRESHOLD")}
          labelDiscount={i18n.get("REPORT_DISCOUNT")}
          keyPrice={"reportPricing"}
          keyThreshold={"reportThreshold"}
          keyDiscount={"reportDiscount"}
        />
        <ReceiptsConfigurationInputs
          labelPrice={i18n.get("INVESTIGATION_CASES_PRICING")}
          labelThreshold={i18n.get("INVESTIGATION_CASES_THRESHOLD")}
          labelDiscount={i18n.get("INVESTIGATION_CASES_DISCOUNT")}
          keyPrice={"investigationCasesPricing"}
          keyThreshold={"investigationCasesThreshold"}
          keyDiscount={"investigationCasesDiscount"}
        />
        <Et3Margin top={20} bottom={0} right={0} left={0} />
        <SaveReceiptsConfiguration />
      </ET3Div>
    );
  }
);
export default SupervisorReceiptConfigurationInput;
